import index from '@/components/conf/index/index.vue'
import empty from '@/components/common/empty/empty.vue'
export default {
    path: '/qrcode',
    component: index,
    redirect: '/qrcode/creat',
    name: '码管理',
    iconCls: '&#xe794;',
    children: [{
        path: 'creat',
        component: resolve => require(['@/components/conf/qrcode/create/index.vue'], resolve),
        name: '二维码生成',
        iconCls: '&#xe803;'
    },{
        path: 'log',
        component: resolve => require(['@/components/conf/qrcode/log/index.vue'], resolve),
        name: '二维码扫描数据',
        iconCls: '&#xe7f8;'
    },{
      path: 'track',
      component: resolve => require(['@/components/conf/qrcode/track/index.vue'], resolve),
      name: 'track码生成',
      iconCls: '&#xe803;'
  }]
}



// WEBPACK FOOTER //
// ./src/router/qrcode.js